import React from 'react';
import { validated } from 'react-custom-validation';

import A from 'components/A';
import Button from 'components/Button';
import Form from 'components/Form';
import FormError from 'components/FormError';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Input from 'components/Input';
import Label from 'components/Label';

import { isEmail, isEqual, isRequired } from 'utils/validations';

class ResetPasswordForm extends React.Component {
    render() {
        let { authError, resetPasswordFormData, userName, handleChange, onValid, onInvalid, $field, $validation } = this.props;
        return (
            <Form className="login-form reset-password-form">
                <FormRow className="instructions">
                    Don't leave this screen! An email has been sent with your activation code. Enter it here with your new password.
                </FormRow>
                <FormRow>
                    <Label htmlFor="txtEmail">Email Address</Label>
                    <Input type="email"
                           id="txtEmail"
                           name="userName"
                           placeholder="Your Account Email"
                           {...$field('userName', (event) => handleChange(event))}
                           value={userName} />
                    {$validation.userName.show && <FormValidationMessage>{$validation.userName.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow>
                    <Label htmlFor="txtCode">Forgot Password Code</Label>
                    <Input type="text"
                           id="txtCode"
                           name="code"
                           placeholder="The code emailed to you"
                           {...$field('code', (event) => handleChange(event))}
                           value={resetPasswordFormData.code} />
                    {$validation.code.show && <FormValidationMessage>{$validation.code.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow>
                    <Label htmlFor="txtPassword">New Password</Label>
                    <Input type="password"
                           id="txtPassword"
                           name="password"
                           placeholder="New password"
                           {...$field('password', (event) => handleChange(event))}
                           value={resetPasswordFormData.password} />
                    {$validation.password.show && <FormValidationMessage>{$validation.password.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow>
                    <Label htmlFor="txtPassword2">Repeat New password</Label>
                    <Input type="password"
                           id="txtPassword2"
                           name="password2"
                           placeholder="Confirm new password"
                           {...$field('password2', (event) => handleChange(event))}
                           value={resetPasswordFormData.password2} />
                    {$validation.password2.show && <FormValidationMessage>{$validation.password2.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormError show={Object.keys(authError).length > 0}>
                    {authError.friendlyMessage ? authError.friendlyMessage : authError.message}
                </FormError>
                <FormRow className="button-wrapper">
                    <Button type="submit"
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(onValid, onInvalid)}}>
                        Change Password
                    </Button>
                </FormRow>
                <FormRow className="login-link--wrapper">
                    <A to="/login">Sign In</A>
                </FormRow>
            </Form>
        )
    }
}

function resetPasswordFormValidationConfig(props) {
    const { code, password, password2} = props.resetPasswordFormData;
    const userName = props.userName;

    return {
        fields: ['code', 'password', 'password2', 'userName'],
        validations: {
            code: [
                [isRequired, code]
            ],
            password: [
                [isRequired, password]
            ],
            password2: [
                [isRequired, password],
                [isEqual, password, password2, 'Passwords do not match']
            ],
            userName: [
                [isRequired, userName],
                [isEmail, userName]
            ]
        }
    }
}

export default ResetPasswordForm = validated(resetPasswordFormValidationConfig)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/AuthPages/ResetPasswordPage/ResetPasswordForm.js